import { css } from 'styled-components';
import {
  screenXsMin,
  screenSmMin,
  screenMdMin,
  screenLgMin,
} from '@spotify-internal/encore-web';

const createMinWidthMediaQuery = (minWidth: string) =>
  `@media (min-width: ${minWidth})`;

const createMaxWidthMediaQuery = (maxWidth: string) =>
  `@media (max-width: ${maxWidth})`;

export const media = {
  mobileXsDown: createMaxWidthMediaQuery(screenXsMin),
  mobileXsUp: createMinWidthMediaQuery(screenXsMin),
  mobileSmUp: createMinWidthMediaQuery(screenSmMin),
  mobileMdUp: createMinWidthMediaQuery(screenMdMin),
  desktopLgUp: createMinWidthMediaQuery(screenLgMin),
};

// Handles button sizing
export const buttonSize = css`
  width: 100%;
  ${media.mobileSmUp} {
    width: auto;
  }
`;
